@if (columnType === 'text') {
  <span class="normal-text">{{ columnData | truncate : 25  }}</span>
} @else {
  @if (columnType === 'link') {
    <a [href]="columnData">{{ columnData }}</a>
  }
  @if (columnType === 'button') {
    <lib-button
      type="button"
      [text]="columnData"
      width="100px"
      height="50px"
      borderRadius="20px"
      class="btn-submit"
      >
    </lib-button>
  }
  @if (columnType === 'date') {
    <span class="normal-text">{{ columnData | date }}</span>
  }
}
